module.exports = __webpack_public_path__ + "img/ic-copy.f43bfa9b.svg";